import { useCallback } from "react"

import { sendCopy, sendOpenLink } from "@/modules/helpers/utils"

/**
 * Hook to handle campaign actions (copy link, copy hashtag, open link)
 * @param campaignData - Campaign data containing link and hashtag
 * @returns Object with handlers for campaign actions
 */
export function useCampaignActions(campaignData?: {
  productLink?: string
  hashtag?: string[]
}) {
  const handleCopyLink = useCallback(() => {
    if (!campaignData?.productLink) return
    sendCopy(campaignData.productLink)
  }, [campaignData?.productLink])

  const handleCopyHashtag = useCallback(() => {
    if (!campaignData?.hashtag?.length) return
    const hashtagText = campaignData.hashtag.join(" ")
    sendCopy(hashtagText)
  }, [campaignData?.hashtag])

  const handleOpenLink = useCallback(() => {
    if (!campaignData?.productLink) return
    sendOpenLink(campaignData.productLink)
  }, [campaignData?.productLink])

  return {
    handleCopyLink,
    handleCopyHashtag,
    handleOpenLink
  }
}
